export const blogCategories = [
  "All",
  "Data engineering",
  "Architecture",
  "Data governance",
  "AI readiness",
  "Analytics",
  "Integration",
  "Automation",
];

export const blogPosts = [
  {
    slug: "platform-agnostic-data-engineering",
    title: "Platform-agnostic data engineering: comparing Fabric, Snowflake, Databricks and AWS by architecture",
    excerpt:
      "A practical comparison of Azure, Snowflake, Databricks and AWS through the lens of ingestion, transformation, medallion architecture, governance, lineage, data quality and semantic layers.",
    href: "/blog/platform-agnostic-data-engineering",
    category: "Architecture",
    date: "June 30, 2026",
    readTime: "14 min read",
    featured: true,
    tags: [
      "Data engineering",
      "Architecture",
      "Data governance",
      "AI readiness",
      "Azure",
      "Snowflake",
      "Databricks",
      "AWS",
    ],
  },
  {
    slug: "testing-data-migrations-python-polars",
    title: "Testing data migrations at scale with Python, Polars and cloud compute",
    excerpt:
      "A practical approach to row-level reconciliation for migration projects, covering Python automation, Polars, distributed compute, dependency groups and medallion architecture.",
    href: "/blog/testing-data-migrations-python-polars",
    category: "Data engineering",
    date: "June 28, 2026",
    readTime: "11 min read",
    featured: false,
    tags: [
      "Data engineering",
      "Architecture",
      "Data governance",
      "Automation",
      "Polars",
      "Python",
    ],
  },
  {
    slug: "living-data-lineage-map",
    title: "Living data lineage map for Power BI, Purview, ADF and SQL",
    excerpt:
      "A practical approach for tracing a dashboard metric back through Power BI visuals, semantic models, Azure Data Factory copy activities, bronze ingestion tables, SQL transformations, curated datasets and source systems.",
    href: "/blog/living-data-lineage-map",
    category: "Data governance",
    date: "June 27, 2026",
    readTime: "10 min read",
    featured: false,
    tags: [
      "Data engineering",
      "Architecture",
      "Data governance",
      "AI readiness",
      "Power BI",
      "Azure Data Factory",
    ],
  },
];
